import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { loginActions, useAppDispatch } from '@modules';

import Button from '@components/Button';
import Restriction from '@components/Restriction';

import DecorImage from './decor.svg';

import style from './Success.scss';

const cn = bemCssModules(style, 'Success');

export const Success: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    navigate(CONST.nav.root);
    dispatch(loginActions.clearProtectNext());
  };
  return (
    <div className={cn(null, [className])}>
      <Restriction
        className={cn(null, [className])}
        title={t('otp.success.header')}
        subtitle={t('otp.success.description')}
        images={['/img/protect/protect.png', <DecorImage />]}
        button={<Button onClick={handleClick}>{t('otp.success.continue')}</Button>}
        isHideLinks
      />
    </div>
  );
};

export default Success;
